<template>
  <v-snackbar :color="errorBackgroundTint" :value="value" @input="emitInput">
    <v-icon color="error" :style="{ color: themeColors.error }" left>{{
      mdiCloseCircle
    }}</v-icon>
    <span
      style="font-family: system-ui !important; font-weight: 500"
      :style="{ color: themeColors.error }"
      >{{ message }}</span
    >
    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        min-width="24"
        text
        color="textColor"
        @click="emitInput(false)"
      >
        <v-icon color="error" :style="{ color: themeColors.error }">{{
          mdiClose
        }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiClose, mdiCloseCircle } from "@mdi/js"
import { errorBackgroundTint } from "constants/theme"
import TextBody from "components/UI/TextBody.vue"
import { useThemeColors } from "features/common/theme/useTheme"

export default defineComponent({
  name: "ErrorSnackbar",
  components: { TextBody },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const emitInput = (value: boolean) => {
      emit("input", value)
    }
    const themeColors = useThemeColors()
    return {
      emitInput,
      mdiCloseCircle,
      errorBackgroundTint,
      themeColors,
      mdiClose,
    }
  },
})
</script>
